import React, { useContext } from 'react'
import DailySalesInnerStyle from './css/DailySalesInnerStyle'
import { Bar } from 'react-chartjs-2'
import { ContentInner } from '../../../../../layout/Content'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'
import { formatNumber, getMonthString } from '../../../../../utilities/utilities'
import { appContext } from '../../../../../../App'
import { dailySalesControllerContext } from './DailySalesController'

function DailySalesInner() {
  const app = useContext(appContext)
  const dailySalesController = useContext(dailySalesControllerContext)
  const dailySales = dailySalesController.dailySales[0]
  const month = dailySalesController.month[0]
  const { yearString } = dailySalesController

  const data = {
    labels: (dailySales) ? dailySales.total_sales.map(ts => ts._id) : null,
    datasets: [
      {
        label: 'Net Sales',
        data: (dailySales) ? dailySales.total_sales.map(ts => ts.total_net_sales) : null,
        backgroundColor: [ 'rgba(255, 99, 132, 0.2)' ],
        borderColor: [ 'rgba(255, 99, 132, 1)' ],
        borderWidth: 1,
      },
      {
        label: 'Gross Sales',
        data: (dailySales) ? dailySales.total_sales.map(ts => ts.total_gross_sales) : null,
        backgroundColor: [ 'rgba(105, 199, 202, 0.2)' ],
        borderColor: [ 'rgba(105, 199, 202, 1)' ],
        borderWidth: 1,
      }
    ]
  }

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div className='daily-sales-report-container printable'>
          <div className='header-wrapper'>
            <div><b>Daily Sales Report</b></div>
            <div>{getMonthString(month)} {yearString}</div>
            <div>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
          </div>
          <br />

          <div className='top-container'>
            <table className='daily-sales-report-table striped'>
              <thead>
                <tr>
                  <th style={{backgroundColor: 'green'}}>Day</th>
                  <th style={{textAlign: 'right', backgroundColor: 'blue', color: 'whitesmoke'}}>Credit Sales</th>
                  <th style={{textAlign: 'right'}}>Net Sales</th>
                  <th style={{textAlign: 'right'}}>Gross Sales</th>
                </tr>
              </thead>
              {
                (dailySales)
                ? dailySales.total_sales.map((ds, i) => (
                    <tbody key={ds._id}>
                      <tr>
                        <td style={{textAlign: 'center'}}>{ds._id}</td>
                        <td style={{textAlign: 'right'}}>{formatNumber(dailySales.credit_sales[i].total_gross_sales)}</td>
                        <td style={{textAlign: 'right'}}>{formatNumber(ds.total_net_sales)}</td>
                        <td style={{textAlign: 'right'}}>{formatNumber(ds.total_gross_sales)}</td>
                      </tr>
                    </tbody>
                  ))
                : null
              }
              <tbody className='total'>
                <tr>
                  <th style={{textAlign: 'center', backgroundColor: 'green'}}>Total</th>
                  <th style={{textAlign: 'right', backgroundColor: 'blue', color: 'whitesmoke'}}>P{
                    (dailySales)
                    ? formatNumber(dailySales.credit_sales.reduce((acc, curr) => (acc + curr.total_gross_sales), 0))
                    : 0.00
                  }
                  </th>
                  <th style={{textAlign: 'right'}}>P{
                    (dailySales)
                    ? formatNumber(dailySales.total_sales.reduce((acc, curr) => (acc + curr.total_net_sales), 0))
                    : 0.00
                  }</th>
                  <th style={{textAlign: 'right'}}>P{
                    (dailySales)
                    ? formatNumber(dailySales.total_sales.reduce((acc, curr) => (acc + curr.total_gross_sales), 0))
                    : 0.00
                  }
                  </th>
                </tr>
              </tbody>
            </table>
          </div>

          <div className='pagebreak'/>

          <div className='bottom-container'>
            <div className='monthly-sales-chart'>
              <Bar
                data={data}
                width={50}
                height={80}
                options={{
                  indexAxis: 'y',
                  maintainAspectRatio: true,
                  plugins: {
                    title: {
                      display: true,
                      text: 'Monthly Sales'
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <DailySalesInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(DailySalesInner)